import TCFProvider from './TCFProvider'

export default TCFProvider

export { useTCF } from './TCFContext'
